module.exports = __webpack_public_path__ + "img/gb.ddc9075c.svg";